export default "__VITE_ASSET__hzfHd9G6__"